import { gql } from '@apollo/client';
import { FUNNEL_PACKET_FRAGMENT } from '../fetch-funnel-packet/fetch-funnel-packet.queries';

export const CREATE_FUNNEL_PACKET = gql`
  mutation Flex_CreateFunnelPacket($input: CreateFunnelPacketInput!) {
    createFunnelPacket(input: $input) {
      ...FunnelPacketData
    }
  }
  ${FUNNEL_PACKET_FRAGMENT}
`;
